import { render, staticRenderFns } from "./AcceptModal.vue?vue&type=template&id=2bedf84c&scoped=true"
import script from "./AcceptModal.vue?vue&type=script&lang=js"
export * from "./AcceptModal.vue?vue&type=script&lang=js"
import style0 from "./AcceptModal.vue?vue&type=style&index=0&id=2bedf84c&prod&lang=scss&scoped=true"
import style1 from "./AcceptModal.vue?vue&type=style&index=1&id=2bedf84c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bedf84c",
  null
  
)

export default component.exports